import {createStyles, Theme} from "@material-ui/core";
import {styleColors} from "src/main.style";

export const dialogStyles = (theme: Theme) => createStyles({
  smallAddButton: {
    width: '28px',
    height: '28px',
    display: 'flex',
    borderRadius: '50px',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: styleColors.mutedCoral,
    cursor: 'pointer',
  },
  listItemItem:{
    height: 'auto',
  },
  smallDeleteButton: {
    position: 'absolute',
    right: '-4px',
    top: '-4px',
    backgroundColor: styleColors.greyLight1,
    padding: '5px',
  },
  fakeButton : {
    backgroundColor: styleColors.white,

  }
});

export const CustomDialogContentStyle = (theme: Theme) => createStyles({
  root: {
    display: 'flex',
    flexDirection: 'column',
    overflowX: 'hidden',
    alignItems: 'stretch',
    gap: theme.spacing(2),
  }
});

export const CustomCheckboxStyle = (theme: Theme) => createStyles({
  root: {
    background: styleColors.greyLight1,
    borderRadius: '4px',
    padding: '6px',
    color: `${styleColors.greyMedium1} !important`,
  },
});

export const CustomTextFieldStyle = (theme: Theme) => createStyles({
  root: {
    background: styleColors.greyLight1,
    borderRadius: '4px',

    '& .MuiInputBase-input': {
      borderRadius: '4px',
      padding: `12px 8px`,
      fontStyle: 'normal',
      fontWeight: 400,
      fontSize: '17px',
      lineHeight: '15px',
      color: styleColors.black,

      '&::placeholder': {
        fontFamily: 'Metropolis',
        fontStyle: 'normal',
        fontWeight: 400,
        fontSize: '10px',
        letterSpacing: '1px',
        textTransform: 'uppercase',
        color: styleColors.warmGrey,
        opacity: 1,
      },
    },
  },
});

export const CustomTextFieldInvertedStyle = (theme: Theme) => createStyles({
  root: {
    padding: `12px 8px`,
    background: styleColors.white,
    '& .MuiInputBase-input': {
      fontFamily: 'Metropolis',
      fontStyle: 'normal',
      fontWeight: 600,
      fontSize: '13px',
      lineHeight: '13px',
      display: 'flex',
      alignItems: 'center',
      textAlign: 'center',
      letterSpacing: '1px',
      textTransform: 'uppercase',
      padding: `0px 8px`,
      background: styleColors.white,
    },
  },
});

export const CustomTextFieldInvertedPStyle = (theme: Theme) => createStyles({
  root: {
    padding: `12px 8px`,
    minHeight: '16px',
    background: styleColors.white,
    '& .MuiInputBase-input': {
      fontFamily: 'Metropolis',
      fontStyle: 'normal',
      fontWeight: 600,
      fontSize: '13px',
      lineHeight: '13px',
      display: 'flex',
      alignItems: 'center',
      textAlign: 'center',
      letterSpacing: '1px',
      textTransform: 'uppercase',
      padding: `0px 8px`,
      background: styleColors.white,

      '&::placeholder': {
        fontSize: '13px',
      },
    },
  },
});

export const CustomSelectStyle = (theme: Theme) => createStyles({
  root: {
    paddingRight: theme.spacing(2),
    background: styleColors.greyLight1,
    backgroundColor: styleColors.greyLight1,
    borderRadius: '4px',
  },
  select: {
    padding: '10px 13px !important',
    display: 'flex',
    alignItems: 'center',
    borderRadius: '4px',
    background: styleColors.greyLight1,
    backgroundColor: styleColors.greyLight1,
  },
  nativeInput: {
    background: styleColors.greyLight1,
    backgroundColor: styleColors.greyLight1,
    borderRadius: '4px',
    padding: `${theme.spacing(2)} ${theme.spacing(1)}`,
    fontStyle: 'normal',
    fontWeight: 400,
    fontSize: '13px',
    lineHeight: '15px',
    display: 'flex',
    alignItems: 'center',
    color: styleColors.black,
  },
  icon: {
    display: 'none',
  },
});

export const CustomSelectInvertedStyle = (theme: Theme) => createStyles({
  root: {
    background: styleColors.white,
    padding: '8px 35px',
    fontSize: '12px',
    fontWeight: 500,
  },
  nativeInput: {
    background: styleColors.white,
    padding: '8px 35px',
  }
});

export const StyledSliderStyle = (theme: Theme) => createStyles({
  root: {
    height: '16px',
    backgroundColor: styleColors.greyLight1,
    color: styleColors.greyLight1,
    border: `1px solid ${styleColors.blackAlpha18}`,
    borderRadius: '17px',
    padding: 0,
    top:'1px',
  },
  thumb: {
    top: '1px',
    width: '24px',
    height: '24px',
    backgroundColor: styleColors.white,
    border: `1px solid ${styleColors.blackAlpha45}`,
    borderRadius: '17px',
  },
  track: {
    opacity:0,
  }
});



// WEBPACK FOOTER //
// ./src/components/economy/DialogComponens.style.ts